import { render } from "./AuthPage.vue?vue&type=template&id=24f82be5"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"
script.render = render

export default script